var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureTab1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 46,
    viewBox: "0 0 33 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1202_83)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1202_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 2.16476V40.2656C33 41.0186 32.8519 41.7643 32.5642 42.4601C32.2765 43.1558 31.8548 43.7879 31.3231 44.3204C30.7915 44.8529 30.1603 45.2753 29.4657 45.5635C28.7711 45.8517 28.0266 46 27.2748 46H5.73176C4.21273 46 2.75583 45.3961 1.6811 44.3208C0.606378 43.2456 0.00173074 41.7871 6.45906e-07 40.2656V18.688C0.00172848 17.1659 0.606166 15.7067 1.6807 14.6304C2.75524 13.5542 4.21213 12.9488 5.73176 12.947H20.7923L29.0505 0.93549C29.313 0.555448 29.6899 0.269265 30.1261 0.118595C30.5623 -0.0320746 31.0352 -0.0393656 31.4758 0.097783C31.9165 0.234932 32.3019 0.509363 32.5761 0.881129C32.8502 1.2529 32.9987 1.70259 33 2.16476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 2.16476V40.2656C33 41.0186 32.8519 41.7643 32.5642 42.4601C32.2765 43.1558 31.8548 43.7879 31.3231 44.3204C30.7915 44.8529 30.1603 45.2753 29.4657 45.5635C28.7711 45.8517 28.0266 46 27.2748 46H5.73176C4.21273 46 2.75583 45.3961 1.6811 44.3208C0.606378 43.2456 0.00173074 41.7871 6.45906e-07 40.2656V18.688C0.00172848 17.1659 0.606166 15.7067 1.6807 14.6304C2.75524 13.5542 4.21213 12.9488 5.73176 12.947H20.7923L29.0505 0.93549C29.313 0.555448 29.6899 0.269265 30.1261 0.118595C30.5623 -0.0320746 31.0352 -0.0393656 31.4758 0.097783C31.9165 0.234932 32.3019 0.509363 32.5761 0.881129C32.8502 1.2529 32.9987 1.70259 33 2.16476Z",
    fill: "url(#paint0_linear_1202_83)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1202_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7441 19.0598C13.8691 19.3176 12.1309 20.0637 10.6895 21.2278C10.2949 21.5481 9.54883 22.2942 9.22852 22.6887C8.24023 23.9114 7.48242 25.5051 7.18164 27.009C6.93945 28.2239 6.93945 29.7786 7.18164 30.9934C7.55664 32.8606 8.5293 34.6653 9.89258 36.0364C10.4551 36.5989 10.8535 36.927 11.5098 37.3645C12.8301 38.2434 14.373 38.7981 15.9785 38.9661C16.5527 39.0247 18.0215 38.9934 18.5254 38.9075C20.3145 38.6067 21.8965 37.9036 23.291 36.7903C23.7168 36.4505 24.4512 35.7161 24.791 35.2903C25.791 34.0364 26.5215 32.4973 26.8223 30.9934C26.9238 30.4856 27.002 29.7942 27.002 29.388V29.0012H25.8105H24.6191V29.3176C24.6191 29.4934 24.5918 29.8215 24.5605 30.052C24.0723 33.3919 21.4355 36.0169 18.0566 36.5208C17.5176 36.6028 16.5176 36.6028 15.9629 36.5208C13.4707 36.1575 11.3418 34.6262 10.2246 32.3997C9.66602 31.2864 9.42383 30.2473 9.42383 28.9778C9.42383 27.7473 9.66992 26.7083 10.2246 25.6028C11.3379 23.384 13.4355 21.8723 15.9434 21.4817C16.4043 21.4114 17.4395 21.3997 17.9199 21.4622C19.0527 21.6067 20.1582 22.009 21.1152 22.6301C21.3223 22.7669 21.4941 22.888 21.4941 22.8997C21.4941 22.9153 21.2988 23.1223 21.0605 23.3606C20.7051 23.72 20.6387 23.802 20.6973 23.8176C20.9277 23.888 24.7832 24.6301 24.8027 24.6106C24.8223 24.5911 24.0762 20.7473 24.0059 20.509C23.9902 20.4505 23.9199 20.5051 23.6074 20.8137L23.2324 21.1887L22.8613 20.9153C21.5137 19.927 19.8887 19.2747 18.2207 19.0637C17.6309 18.9856 16.291 18.9856 15.7441 19.0598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0693 23.79C13.9287 24.1494 12.1396 25.9541 11.7881 28.1025C11.7139 28.5791 11.7139 29.4229 11.7881 29.8994C12.1396 32.0635 13.9404 33.8643 16.1045 34.2158C16.5811 34.29 17.4248 34.29 17.9014 34.2158C20.0654 33.8643 21.8662 32.0635 22.2178 29.8994C22.292 29.4229 22.292 28.5791 22.2178 28.1025C21.8662 25.9346 20.0693 24.1377 17.9014 23.7861C17.4443 23.7119 16.5186 23.7158 16.0693 23.79ZM18.0771 29.8994L16.417 31.5596L15.3428 30.4854L14.2686 29.4111L14.667 29.0127L15.0693 28.6104L15.7412 29.2822L16.417 29.958L17.6748 28.7002L18.9365 27.4385L19.335 27.8369L19.7373 28.2393L18.0771 29.8994Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1202_83",
    x: -8,
    y: -5,
    width: 51,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1202_83"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1202_83",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1202_83",
    x1: 33,
    y1: 22.997,
    x2: 0.00652899,
    y2: 22.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC1E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1202_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 46,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1202_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(7 19)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTab1);
export default __webpack_public_path__ + "static/media/feature_tab1.c964c034c0d5d63e243398d17e3cf8c6.svg";
export { ForwardRef as ReactComponent };